export default __webpack_public_path__ + "static/media/svg-4.78caaaf4.svg";